import { useState, useEffect } from 'react';
import { expenseRequestsAPI } from '@/lib/api';

let cached = null;
let inflight = null;
const EMPTY = { is_admin: false, is_reviewer: false, loaded: false };

export const useExpenseRole = () => {
  const [role, setRole] = useState(cached || EMPTY);
  useEffect(() => {
    if (cached) return;
    inflight = inflight || expenseRequestsAPI.myRole()
      .then(r => { cached = { ...r.data, loaded: true }; return cached; })
      .catch(() => { inflight = null; return { ...EMPTY, loaded: true }; });
    inflight.then(setRole);
  }, []);
  return role;
};

export const resetExpenseRole = () => { cached = null; inflight = null; };
